import React from 'react';
import appStoreBadge from '../../images/home/badges/app-store-badge.svg';
import googlePlayBadge from '../../images/home/badges/google-play-badge.svg';
import { APP_STORE_URL, GOOGLE_PLAY_URL, CtaLocation, trackStoreClick } from './links';

type Props = { location: CtaLocation };

/**
 * App Store and Google Play badges. The artwork lives in
 * src/images/home/badges/ so the official files can be dropped in under the
 * same names without touching this component.
 */
const StoreBadges = ({ location }: Props) => (
  <div className="bh-badges">
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackStoreClick('ios', location)}
    >
      <img src={appStoreBadge} alt="Download on the App Store" width={156} height={52} />
    </a>
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackStoreClick('android', location)}
    >
      <img src={googlePlayBadge} alt="Get it on Google Play" width={176} height={52} />
    </a>
  </div>
);

export default StoreBadges;
